export default __webpack_public_path__ + "static/media/github.a61b960f.svg";